import { isNil } from "lodash-es";
import { ensure, ensureArray, stringType, TType } from "types";

import { configIdType, configPageableMetaType, IId, IPageable, IPartialPageable } from "@/core/api";
import { ICodelist } from "@/data/codelists";

export interface IRole extends IId {
  name: string;
}

export const configRoleType: TType<IRole> = {
  ...configIdType,
  name: stringType(""),
};

export const roleType = ensure(configRoleType);

export interface ICreateRoleDto {
  name: string;
}

export interface IConsultantProfileRole {
  role: IRole;
  roleLevel: ICodelist["code"];
}

const configConsultantProfileRole: TType<IConsultantProfileRole> = {
  role: v => (isNil(v) ? null : roleType(v)),
  roleLevel: stringType(null),
};

export const consultantProfileRoleType = ensure(configConsultantProfileRole);

export interface IPageableRole extends IPageable<IRole[]> {}

export const pageableRoleTypeConfig: TType<IPageableRole> = {
  ...configPageableMetaType,
  content: ensureArray(roleType),
};

export const pageableRoleType = ensure(pageableRoleTypeConfig);

export interface IPartialPageableRole extends IPartialPageable<IRole[]> {}
